import { Country } from 'api';
import { yup } from 'form';

export const tradingDashboardFiltersFormSchema = yup.object({
  account_managers: yup
    .array()
    .of(
      yup.object({
        id: yup.number().required(),
      })
    )
    .optional(),
  demand_signals: yup.array().of(yup.object()).min(1).required(),
  exclude_country: yup.string().oneOf(Object.values(Country)).optional(),
  material: yup.number().required(),
  material_forms: yup
    .array()
    .of(
      yup.object({
        id: yup.number().required(),
        type: yup.string().required(),
      })
    )
    .optional(),
  max_grade: yup.number().emptyAsUndefined().min(0).optional(),
  min_grade: yup.number().emptyAsUndefined().min(0).optional(),
  seller_id: yup.number().optional(),
  signals_country: yup.string().oneOf(Object.values(Country)).optional(),
  site_material_country: yup.string().oneOf(Object.values(Country)).optional(),
  site_material_region: yup.string().optional(),
  target_margin: yup.number().min(0).optional(),
});
